export const categoryItems = [
  // categoryId1 start from here {diabetics}
  {
    id: 654,
    catego0ryId: 1,
    itemName:
      "Virgo Healthcare Protivir Diet- Nutritional Supplement for Diabetic",
    offerPrice: "2333",
    itemPrice: "2000",
    ratingPoints: "4.5",
    ratingReview: "294 Ratings & 34 Reviews",
    offPercentage: "15% off",
    itemInfo:
      "is a nutritional drink for diabetics with 26 vital vitamins and minerals that help manage blood sugar, weight and strength. It is high in fibre and protein and has a low glycemic index.",
    highlights: [
      "It has low fat content and no added sugar",
      "Provides the right nutrition to stay healthy and active",
      "Enriched with antioxidants and essential vitamins and minerals to meet the increased requirements of diabetics",
    ],
    desc: {
      keybenefit: [
        "It ensures beneficial effects in general debility, malnutrition, neuropathies, stress, and strains",
        "Protein supplement for specific nutritional needs of diabetic patients, people having high cholesterol level and problems with the weight management",
        "It is also effective in weight management and pregnancy",
        "It helps release anabolic hormones that stimulate muscle growth",
      ],
      directions: [
        "Take Virgo Healthcare Protivir Diet Protein Powder (Sugar-Free)as directed by the physician.",
        "Consume 1-2 times a day before meals or as directed by physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the recommended dose",
        "Keep out of the reach of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/zl35i9inmpsoj2tmga2a.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/p8cjjuj9qbdrikxet8s6.png",
    categoryImgName: "Bourn Vita",
  },
  {
    id: 542,
    categoryId: 1,
    itemName: "PentaSure DM Diabetes Care Powder Creamy Vanilla & Cinnamon",
    offerPrice: "1500",
    itemPrice: "1000",
    ratingPoints: "4.3",
    ratingReview: "265 Ratings & 94 Reviews",
    offPercentage: "5% off",
    highlights: [
      "Helps control blood sugar levels",
      "Formulated as per ADA and WHO guidelines",
      "Enriched with fibre and omega-3 fatty acid",
      "Contains high-quality whey protein",
    ],
    desc: {
      keybenefit: [
        "It improves insulin sensitivity",
        "It contains dietary fibre that helps improve digestion",
        "Helps maintain a low glycemic index",
        "Helps prevent diabetic neuropathy",
      ],
      directions: [
        "Add 50 grams (4 level scoops) to 200 ml water",
        "Stir thoroughly and consume immediately",
        "Stir well and enjoy",
        "It can also be with milk & cornflakes, porridge or curd",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/akatbzesklvi4vtyro1g.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/eq1ot7mqxqr4jkd73kf1.png",
    categoryImgName: "Omega & Fish Oil",
  },
  {
    id: 453,
    categoryId: 1,
    itemName:
      "Contour Plus One Blood Glucose Monitoring System Glucometer with Contour Plus Blood Glucose Test Strip 10S Free",
    offerPrice: "999",
    itemPrice: "777",
    ratingPoints: "3.8",
    ratingReview: "189 Ratings & 76 Reviews",
    offPercentage: "10% off",
    highlights: [
      "Different light indicators show the results in their respective ranges",
      "Smartlight feature indicates cases of high or low blood glucose level",
      "Second chance sampling reduces the need for second time lancing and strip wastage",
      "Can be connected to an app for detailed report",
    ],
    desc: {
      keybenefit: [
        "smartLIGHT Feature: Makes it quick and easy to interpret blood glucose readings using coloured lights",
        "The different lights and their indications are Amber - above target range, Green - within target range, and Red - below target range",
        "Second-chance sampling: Prompts the user to reapply blood if the first sample is insufficient to take a reading",
        "This helps avoid lancing a second time and wasting strips",
      ],
      directions: [
        "Insert the test strip with the grey square end facing the meter (this will automatically turn on the meter)",
        "Immediately add blood to the test strip",
        "The result is displayed (after marking as fasting, before/after a meal or no note)",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/mpraei9nq1cjrgsbhrdr.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/ogtn4geufd0vbvn6ft3k.png",
    categoryImgName: "Weight & Drinks",
  },
  {
    id: 6454,
    categoryId: 1,
    itemName: "Protinex Diabetes Care Vanilla",
    itemPrice: "500",
    offerPrice: "580",
    highlights: [
      "Helps maintain blood sugar levels",
      "Meets protein and fibre requirements in patients with diabetes",
      "High in fibre and protein",
      "Low glycemic index and fat",
    ],
    desc: {
      keybenefit: [
        "Has a low GI level of 17 that helps maintain blood sugar levels",
        "It contains dietary fibre that promotes satiety and supports weight management",
        "It is rich in protein that helps build strength and increase energy",
        "Low in fat and contains no added sugar",
      ],
      directions: [
        "Take a mug of lukewarm or cold milk (200ml)",
        "Add 2-3 tablespoons (25g) of Protinex® Diabetes Care Vanilla",
        "Stir well and enjoy",
        "It can also be with milk & cornflakes, porridge or curd",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/xg9w5mk9wvijr6hky8fx.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/ligqeno0mnmr2v3ejkda.png",
    categoryImgName: "Health Food",
  },
  {
    id: 6465,
    categoryId: 1,
    itemName:
      "Dr Morepen Gluco One BG 03 Blood Glucose Test Strip (Only Strips)",
    itemPrice: "555",
    offerPrice: "669",
    highlights: [
      "Reliable and convenient to use with a glucometer",
      "Self-testing method",
      "Requires a tiny drop of blood",
    ],
    desc: {
      keybenefit: [
        "Reliable and convenient to use with a glucometer",
        "Self-testing method",
        "Requires a tiny drop of blood",
      ],
      directions: [
        "The first step is to wash hands with soap and water",
        "An alcohol swab can be used to clean the finger before testing but ensure the fingertip is completely dry before test",
        "Remove the test strip from the box of strips",
        "Insert it into the slot on the glucometer just before pricking the finger",
        "Wipe off the first drop gently, and then put a drop or two onto the designated place on a test strip attached to the glucometer",
      ],
      info: [
        "Content: Test strips, no glucometer device, strips in a box intended for single, one-time use",
        "Minimum blood sample needed: 0.5 microlitres",
        "Provides information on how the program affects the blood glucose level",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/pc0kfczcu5phbkk5sy41.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/pae8ardj2unddupp36la.png",
    categoryImgName: "Vitamins",
  },
  {
    id: 66451,
    categoryId: 1,
    itemName:
      "Tata 1mg Ceylon Cinnamon 10:1 Ratio Extract for Blood Sugar Management 200mg Capsule",
    itemPrice: "999",
    offerPrice: "1200",
    highlights: [
      "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
      "Ceylon cinnamon supports the immune health",
      "Ceylon cinnamon helps to enhance the antioxidant enzyme activity",
    ],
    desc: {
      keybenefit: [
        "Supports healthy blood sugar levels",
        "Ceylon cinnamon is taken to scale back spams, gas (flatulence), improve the appetite and fight bacteria and fungi",
        "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
        "Ceylon cinnamon supports the immune health",
      ],
      directions: [
        "Take one capsule with a meal, or as advised by the dietitian or physician. Recommended one capsule daily for adults.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place",
        "FOOD FOR SPECIAL DIETARY USE. Food for Pre-diabetics and diabetics",
        "NOT FOR MEDICINAL USE. This Product is not to be used by pregnant women, nursing mothers or by infants, children, adolescents & the elderly, except when medically advised",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/eds6ghegqiwdxfbzgeeq.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/b855u2cmitwjv5wfjr1q.png",
    categoryImgName: "Protein Supplements",
  },
  {
    id: 68457,
    categoryId: 1,
    itemName:
      "Tata 1mg Diabetes Care Combo Pack for Blood Sugar & Cholestrol Management",
    itemPrice: "652",
    offerPrice: "815",
    highlights: [
      "This combo pack contains 4 items",
      "1mg Ceylon Cinnamon Extract Capsule is formulated with ceylon cinnamon, also known as “true” cinnamon has been prized for its medicinal properties for thousands of years. It can lower blood sugar levels, reduce risk factors for heart diseases and has a plethora of other impressive health benefits.",
    ],
    desc: {
      keybenefit: [
        "Supports healthy blood sugar levels",
        "Ceylon cinnamon is taken to scale back spams, gas (flatulence), improve the appetite and fight bacteria and fungi",
        "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
        "Ceylon cinnamon supports the immune health",
      ],
      directions: [
        "Take one capsule with a meal, or as advised by the dietitian or physician. Recommended one capsule daily for adults.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place",
        "FOOD FOR SPECIAL DIETARY USE. Food for Pre-diabetics and diabetics",
        "NOT FOR MEDICINAL USE. This Product is not to be used by pregnant women, nursing mothers or by infants, children, adolescents & the elderly, except when medically advised",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uca5jm0uqfqpjoyydzh0.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/hyz3alaomnsvodlfr6yn.png",
    categoryImgName: "Homeopathy",
  },
  {
    id: 687468,
    categoryId: 1,
    itemName: "Sugar Free Green Stevia Pellets",
    itemPrice: "182",
    highlights: [
      "Sweetener made from 1% natural stevia leaves",
      "Sweet, just like sugar, but with no calories from sugar",
      "Can be used for a variety of hot and cold beverages",
      "Safe for the entire family to consume, including kids",
    ],
    desc: {
      keybenefit: [
        "SugarFree Green can be used for a wide variety of preparations such as hot and cold beverages, sweets, desserts, cakes etc",
        "Sweet, just like sugar, but with no calories from sugar",
        "Safe for the entire family to consume, including kids",
        "1 pellet of sugar-free green is equal to 1 tsp sugar in sweetness",
      ],
      directions: ["Use as directed by the health-care professional."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uca5jm0uqfqpjoyydzh0.jpg",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/cv1so1bd03epqno2z3to.png",
    categoryImgName: "Chia , Flax",
  },

  {
    id: 968745,
    categoryId: 1,
    itemName:
      "Baidyanath Basant Kusumakar Ras (S.C.M.Yu) with Gold, Silver & Pearl Maintains Blood Glucose Level",
    itemPrice: "2359",
    highlights: [
      "Helps control blood glucose levels",
      "Improves fatigue and general weakness",
      "Can help with urinary infections and sexual debility",
      "Useful for asthma and phthisis",
    ],
    desc: {
      keybenefit: [
        "Helps maintain blood glucose levels and manage diabetes",
        "It can help improve asthma and general weakness",
        "Useful for urinary infections, phthisis, and sexual debility",
        "Improves frailty of the heart and brain",
      ],
      directions: ["One tablet with water twice a day."],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/dru5ne9rnikqsgayenyy.png",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/ea44f383-a965-4c76-8410-2b09521b06b8.webp",
    categoryImgName: "Aller Aid",
  },
  {
    id: 1658450,
    categoryId: 1,
    itemName: "D-Protin Powder Chocolate",
    itemPrice: "506",
    highlights: [
      "Sugar-free, gluten-free and trans-fat-free",
      "Suitable for diabetics and pre-diabetics",
      "Contains protein, vitamins and minerals",
      "Helps improve the overall health",
    ],
    desc: {
      keybenefit: [
        "Has a low glycemic index of 38.8",
        "Suitable for type 1 diabetes, type 2 diabetes, gestational diabetes, and even pre-diabetes",
        "It provides the body with essential vitamins and minerals",
        "It helps boost strength and immunity",
      ],
      directions: [
        "Take two tablespoons of D-Protin Powder twice a day with lukewarm milk or water",
        "Stir well until completely dissolved",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/dru5ne9rnikqsgayenyy.png",
    categoryImg:
      "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/quxjulqgldr5mwacoadc.png",
    categoryImgName: "Born Vita",
  },
  // categoryId2 start from here {cardiac}
  {
    id: 15451,
    categoryId: 2,
    itemName: "Tata 1mg CoQ 10 (Coenzyme 10) Capsules for Heart Health",
    itemPrice: "644",
    highlights: [
      "It supports heart and vascular health",
      "Promotes healthy cellular function",
      "Contains protein, vitamins and minerals",
      "Strong antioxidant which protects cells from damage",
    ],
    desc: {
      keybenefit: [
        "It supports heart and vascular health",
        "Helps prevent cell damage",
        "Promotes healthy heart and cellular function",
        "It may help prevent heart conditions such as heart failure, congestive heart failure, chest pain (angina), and high blood pressure",
      ],
      directions: [
        "Take one soft gel capsule daily after a meal or as suggested by a healthcare professional.",
      ],
      Safetyinfo: [
        "Protect from light and moisture",
        "This product is not intended to diagnose, treat, cure or prevent any disease",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/dj9v8xuxcpfoseulq96n.jpg",
  },
  {
    id: 12,
    categoryId: 2,
    itemName: "Omron HEM 7124-IN BP Monitor",
    itemPrice: "1940",
    highlights: [
      "Helps to detect blood pressure along with pulse rate",
      "Includes hypertension indicator",
      "Compromises of easy one-touch operations",
      "Provides quick, precise, and reliable results",
    ],
    desc: {
      keybenefit: [
        "Omron HEM-7124-IN BP Monitor is designed to track the blood pressure level of an individual. The machine comes with hypertension indicator and also keeps the memory of last reading.",
      ],
      directions: ["Use as per requirement or as directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ss1kepn3xokqa6kywtkq.jpg",
  },
  {
    id: 13,
    categoryId: 2,
    itemName:
      "Carbamide Forte Cold Pressed Flaxseed Oil 1000mg with Omega 3,6 & 9 825mg Softgel Capsule",
    itemPrice: "499",
    highlights: [
      "It helps maintain a healthy heart",
      "Used to strengthen the immune system",
      "Helps in maintaining the softness of the skin",
      "Used to prevent hair fall",
    ],
    desc: {
      keybenefit: [
        "Flaxseed oil offers a cleaner, more sustainable, plant-based source of omega-3 fatty acid 1000mg compared to fish oil supplements",
        "It helps strengthen the immune system",
        "It helps in maintaining a healthy digestive and cardiovascular system",
        "Helps to soothe skin irritation and softens rough skin",
      ],
      directions: [
        "Take one daily with a meal or as directed by your healthcare professional. ",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/nhqfb8zmstolcbamt82x.jpg",
  },
  {
    id: 14,
    categoryId: 2,
    itemName: "Jubilant Nutrihance UB Gold 150mg of CoQ10 Veg Softgel Caps",
    itemPrice: "540",
    highlights: [
      "Gluten-free and paraben-free",
      "It provides antioxidant support and may improve immunity",
      "It supports heart, joint and brain health",
    ],
    desc: {
      keybenefit: [
        "It is a dietary supplement that improves immune health and provides antioxidant support",
        "Coenzyme Q-10 is a fat-soluble, vitamin-like compound that helps in the production of cellular energy",
        "It serves as an antioxidant that defends the body against free radicals and promotes heart health",
        "It may reduce oxidative damage and inflammation and increase ATP production",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/va0s2aabkymu9fiwbevo.jpg",
  },
  {
    id: 15,
    categoryId: 2,
    itemName:
      "Orange Packets 1000mg Natural Vitamin C & Zinc Effervescent Tablet (15 Each) Orange",
    itemPrice: "667",
    highlights: [
      "Increases the activity of antibodies to boost the immune system",
      "It helps with faster wound healing",
      "Improves collagen production to reduce wrinkles",
    ],
    desc: {
      keybenefit: [
        "Zinc, a vital nutrient for the body, helps to improve immunity, keep blood sugar under check, improve severe acne and decrease heart disease risk",
        "It helps to enhance the body’s immunity, making it easier to help fight against infections",
        "The tablet acts as an antioxidant and helps strengthen the skin’s barriers",
        "It helps to heal the skin cells and depends on vitamin C levels in the body",
      ],
      directions: ["Use as directed on the label."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/rtfodjibnc07hakswqsb.jpg",
  },
  {
    id: 16,
    categoryId: 2,
    itemName:
      "Carbamide Forte Cold Pressed Flaxseed Oil 1250mg Softgel Capsule",
    itemPrice: "349",
    highlights: [
      "It is an immune system booster for a healthier heart",
      "Helps to keep the hair, skin and nails healthy",
      "Help hydrate your skin and supply the best-known nutrients to support hair growth and nail strength",
    ],
    desc: {
      keybenefit: [
        "Flaxseed oil offers a cleaner, more sustainable, plant-based source of omega-3 fatty acid 1000mg",
        "The cold-pressed flaxseed oil is carefully extracted from organic, non-GMO flax seeds without the use of hexane or added heat, helping to preserve the delicate structure of the omega-3s",
        "With natural sources of ALA and omega 3 fatty acids, research is finding that organic flaxseed oil can help you feel more energized by helping your heart work more efficiently and naturally",
        "The essential omega 3 fatty acids in flaxseed oil help hydrate your skin and supply the best-known nutrients to support hair growth and nail strength",
      ],
      directions: [
        "Take one softgel daily with a meal or as directed by your healthcare professional. ",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/xx0zp8n7relw30sh0jeu.jpg",
  },
  {
    id: 17,
    categoryId: 2,
    itemName: "Vitaminnica Neuro Force Veg Capsule",
    itemPrice: "959",
    highlights: [
      "Helps boost immunity",
      "Supports cardiovascular health",
      "Helps prevent cellular damage",
    ],
    desc: {
      keybenefit: [
        "The formulation helps to promote a better mood and maintain optimal health",
        "The capsules help to improve the function of the nervous and the immune system",
        "They support brain function and help improve cardiovascular health",
      ],
      directions: [
        "Use as directed on the label or as advised by the physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/8eef2b9bfc8e43618f3df2d384903949.jpg",
  },
  {
    id: 18,
    categoryId: 2,
    itemName: "Zingavita Omega 3 Fish Oil 1000mg Soft Gelatin Capsule",
    itemPrice: "249",
    highlights: [
      "Free from sugar, soy and gluten",
      "Promotes a healthy heart",
      "Promotes good cognitive health",
    ],
    desc: {
      keybenefit: [
        "It is free from sugar, soy and gluten",
        "It promotes a healthy heart",
        "It promotes good cognitive health",
        "It can help support eye health",
      ],
      directions: [
        "Daily 1 tablet after lunch or dinner. Do not take on an empty stomach.",
        "Zingavita supplements work best along with a healthy diet, regularly drinking water, and good sleep",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ivxygrk9z7qhpegk3zkd.jpg",
  },
  {
    id: 19,
    categoryId: 2,
    itemName: "Jubilant Nutrihance UB Gold 150mg of CoQ10 Veg Softgel Caps",
    itemPrice: "1085",
    highlights: [
      "Gluten-free and paraben-free",
      "It provides antioxidant support and may improve immunity",
      "It supports heart, joint and brain health",
    ],
    desc: {
      keybenefit: [
        "It is a dietary supplement that improves immune health and provides antioxidant support",
        "Coenzyme Q-10 is a fat-soluble, vitamin-like compound that helps in the production of cellular energy",
        "It serves as an antioxidant that defends the body against free radicals and promotes heart health",
        "It may reduce oxidative damage and inflammation and increase ATP production",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ubd4j4r7oxr4lehax28k.jpg",
  },
  {
    id: 20,
    categoryId: 2,
    itemName: "Argipreg Granules",
    itemPrice: "1085",
    highlights: [
      "Promotes growth and development of the body",
      "It can boost athletic performance",
      "Supports cardiovascular and immune health",
    ],
    desc: {
      keybenefit: [
        "It helps improve blood circulation in the body by relaxing the blood vessels",
        "Proanthocyanidin promotes immune and cardiovascular function",
        "It helps improve high blood sugar levels and high blood pressure",
        "It promotes muscle development and supports athletic performance",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/o42s0ximi17m0gfzv13s.jpg",
  },
  // categoryId1 start from here {diabetics}
  {
    id: 654,
    categoryId: 1,
    itemName:
      "Virgo Healthcare Protivir Diet- Nutritional Supplement for Diabetic",
    offerPrice: "2333",
    itemPrice: "2000",
    ratingPoints: "4.5",
    ratingReview: "294 Ratings & 34 Reviews",
    offPercentage: "15% off",
    itemInfo:
      "is a nutritional drink for diabetics with 26 vital vitamins and minerals that help manage blood sugar, weight and strength. It is high in fibre and protein and has a low glycemic index.",
    highlights: [
      "It has low fat content and no added sugar",
      "Provides the right nutrition to stay healthy and active",
      "Enriched with antioxidants and essential vitamins and minerals to meet the increased requirements of diabetics",
    ],
    desc: {
      keybenefit: [
        "It ensures beneficial effects in general debility, malnutrition, neuropathies, stress, and strains",
        "Protein supplement for specific nutritional needs of diabetic patients, people having high cholesterol level and problems with the weight management",
        "It is also effective in weight management and pregnancy",
        "It helps release anabolic hormones that stimulate muscle growth",
      ],
      directions: [
        "Take Virgo Healthcare Protivir Diet Protein Powder (Sugar-Free)as directed by the physician.",
        "Consume 1-2 times a day before meals or as directed by physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the recommended dose",
        "Keep out of the reach of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/zl35i9inmpsoj2tmga2a.jpg",
  },
  {
    id: 542,
    categoryId: 1,
    itemName: "PentaSure DM Diabetes Care Powder Creamy Vanilla & Cinnamon",
    itemPrice: "1000",
    offerPrice: "1500",
    highlights: [
      "Helps control blood sugar levels",
      "Formulated as per ADA and WHO guidelines",
      "Enriched with fibre and omega-3 fatty acid",
      "Contains high-quality whey protein",
    ],
    desc: {
      keybenefit: [
        "It improves insulin sensitivity",
        "It contains dietary fibre that helps improve digestion",
        "Helps maintain a low glycemic index",
        "Helps prevent diabetic neuropathy",
      ],
      directions: [
        "Add 50 grams (4 level scoops) to 200 ml water",
        "Stir thoroughly and consume immediately",
        "Stir well and enjoy",
        "It can also be with milk & cornflakes, porridge or curd",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/akatbzesklvi4vtyro1g.jpg",
  },
  {
    id: 453,
    categoryId: 1,
    itemName:
      "Contour Plus One Blood Glucose Monitoring System Glucometer with Contour Plus Blood Glucose Test Strip 10S Free",
    itemPrice: "999",
    offerPrice: "1100",
    highlights: [
      "Different light indicators show the results in their respective ranges",
      "Smartlight feature indicates cases of high or low blood glucose level",
      "Second chance sampling reduces the need for second time lancing and strip wastage",
      "Can be connected to an app for detailed report",
    ],
    desc: {
      keybenefit: [
        "smartLIGHT Feature: Makes it quick and easy to interpret blood glucose readings using coloured lights",
        "The different lights and their indications are Amber - above target range, Green - within target range, and Red - below target range",
        "Second-chance sampling: Prompts the user to reapply blood if the first sample is insufficient to take a reading",
        "This helps avoid lancing a second time and wasting strips",
      ],
      directions: [
        "Insert the test strip with the grey square end facing the meter (this will automatically turn on the meter)",
        "Immediately add blood to the test strip",
        "The result is displayed (after marking as fasting, before/after a meal or no note)",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/mpraei9nq1cjrgsbhrdr.jpg",
  },
  {
    id: 6454,
    categoryId: 1,
    itemName: "Protinex Diabetes Care Vanilla",
    itemPrice: "500",
    offerPrice: "580",
    highlights: [
      "Helps maintain blood sugar levels",
      "Meets protein and fibre requirements in patients with diabetes",
      "High in fibre and protein",
      "Low glycemic index and fat",
    ],
    desc: {
      keybenefit: [
        "Has a low GI level of 17 that helps maintain blood sugar levels",
        "It contains dietary fibre that promotes satiety and supports weight management",
        "It is rich in protein that helps build strength and increase energy",
        "Low in fat and contains no added sugar",
      ],
      directions: [
        "Take a mug of lukewarm or cold milk (200ml)",
        "Add 2-3 tablespoons (25g) of Protinex® Diabetes Care Vanilla",
        "Stir well and enjoy",
        "It can also be with milk & cornflakes, porridge or curd",
      ],
      info: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool and dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/xg9w5mk9wvijr6hky8fx.jpg",
  },
  {
    id: 6465,
    categoryId: 1,
    itemName:
      "Dr Morepen Gluco One BG 03 Blood Glucose Test Strip (Only Strips)",
    itemPrice: "555",
    offerPrice: "669",
    highlights: [
      "Reliable and convenient to use with a glucometer",
      "Self-testing method",
      "Requires a tiny drop of blood",
    ],
    desc: {
      keybenefit: [
        "Reliable and convenient to use with a glucometer",
        "Self-testing method",
        "Requires a tiny drop of blood",
      ],
      directions: [
        "The first step is to wash hands with soap and water",
        "An alcohol swab can be used to clean the finger before testing but ensure the fingertip is completely dry before test",
        "Remove the test strip from the box of strips",
        "Insert it into the slot on the glucometer just before pricking the finger",
        "Wipe off the first drop gently, and then put a drop or two onto the designated place on a test strip attached to the glucometer",
      ],
      info: [
        "Content: Test strips, no glucometer device, strips in a box intended for single, one-time use",
        "Minimum blood sample needed: 0.5 microlitres",
        "Provides information on how the program affects the blood glucose level",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/pc0kfczcu5phbkk5sy41.jpg",
  },
  {
    id: 66451,
    categoryId: 1,
    itemName:
      "Tata 1mg Ceylon Cinnamon 10:1 Ratio Extract for Blood Sugar Management 200mg Capsule",
    itemPrice: "999",
    offerPrice: "1200",
    highlights: [
      "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
      "Ceylon cinnamon supports the immune health",
      "Ceylon cinnamon helps to enhance the antioxidant enzyme activity",
    ],
    desc: {
      keybenefit: [
        "Supports healthy blood sugar levels",
        "Ceylon cinnamon is taken to scale back spams, gas (flatulence), improve the appetite and fight bacteria and fungi",
        "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
        "Ceylon cinnamon supports the immune health",
      ],
      directions: [
        "Take one capsule with a meal, or as advised by the dietitian or physician. Recommended one capsule daily for adults.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place",
        "FOOD FOR SPECIAL DIETARY USE. Food for Pre-diabetics and diabetics",
        "NOT FOR MEDICINAL USE. This Product is not to be used by pregnant women, nursing mothers or by infants, children, adolescents & the elderly, except when medically advised",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/eds6ghegqiwdxfbzgeeq.jpg",
  },
  {
    id: 68457,
    categoryId: 1,
    itemName:
      "Tata 1mg Diabetes Care Combo Pack for Blood Sugar & Cholestrol Management",
    itemPrice: "652",
    offerPrice: "815",
    highlights: [
      "This combo pack contains 4 items",
      "1mg Ceylon Cinnamon Extract Capsule is formulated with ceylon cinnamon, also known as “true” cinnamon has been prized for its medicinal properties for thousands of years. It can lower blood sugar levels, reduce risk factors for heart diseases and has a plethora of other impressive health benefits.",
    ],
    desc: {
      keybenefit: [
        "Supports healthy blood sugar levels",
        "Ceylon cinnamon is taken to scale back spams, gas (flatulence), improve the appetite and fight bacteria and fungi",
        "Ceylon cinnamon contains anti-inflammatory, antioxidant and antimicrobial properties",
        "Ceylon cinnamon supports the immune health",
      ],
      directions: [
        "Take one capsule with a meal, or as advised by the dietitian or physician. Recommended one capsule daily for adults.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place",
        "FOOD FOR SPECIAL DIETARY USE. Food for Pre-diabetics and diabetics",
        "NOT FOR MEDICINAL USE. This Product is not to be used by pregnant women, nursing mothers or by infants, children, adolescents & the elderly, except when medically advised",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uca5jm0uqfqpjoyydzh0.jpg",
  },
  {
    id: 687468,
    categoryId: 1,
    itemName: "Sugar Free Green Stevia Pellets",
    itemPrice: "182",
    highlights: [
      "Sweetener made from 1% natural stevia leaves",
      "Sweet, just like sugar, but with no calories from sugar",
      "Can be used for a variety of hot and cold beverages",
      "Safe for the entire family to consume, including kids",
    ],
    desc: {
      keybenefit: [
        "SugarFree Green can be used for a wide variety of preparations such as hot and cold beverages, sweets, desserts, cakes etc",
        "Sweet, just like sugar, but with no calories from sugar",
        "Safe for the entire family to consume, including kids",
        "1 pellet of sugar-free green is equal to 1 tsp sugar in sweetness",
      ],
      directions: ["Use as directed by the health-care professional."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "Store in a cool dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uca5jm0uqfqpjoyydzh0.jpg",
  },
  {
    id: 968745,
    categoryId: 1,
    itemName:
      "Baidyanath Basant Kusumakar Ras (S.C.M.Yu) with Gold, Silver & Pearl Maintains Blood Glucose Level",
    itemPrice: "2359",
    highlights: [
      "Helps control blood glucose levels",
      "Improves fatigue and general weakness",
      "Can help with urinary infections and sexual debility",
      "Useful for asthma and phthisis",
    ],
    desc: {
      keybenefit: [
        "Helps maintain blood glucose levels and manage diabetes",
        "It can help improve asthma and general weakness",
        "Useful for urinary infections, phthisis, and sexual debility",
        "Improves frailty of the heart and brain",
      ],
      directions: ["One tablet with water twice a day."],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/dru5ne9rnikqsgayenyy.png",
  },
  {
    id: 1658450,
    categoryId: 1,
    itemName: "D-Protin Powder Chocolate",
    itemPrice: "506",
    highlights: [
      "Sugar-free, gluten-free and trans-fat-free",
      "Suitable for diabetics and pre-diabetics",
      "Contains protein, vitamins and minerals",
      "Helps improve the overall health",
    ],
    desc: {
      keybenefit: [
        "Has a low glycemic index of 38.8",
        "Suitable for type 1 diabetes, type 2 diabetes, gestational diabetes, and even pre-diabetes",
        "It provides the body with essential vitamins and minerals",
        "It helps boost strength and immunity",
      ],
      directions: [
        "Take two tablespoons of D-Protin Powder twice a day with lukewarm milk or water",
        "Stir well until completely dissolved",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in an airtight container to avoid hardening",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/dru5ne9rnikqsgayenyy.png",
  },
  // categoryId2 start from here {cardiac}
  {
    id: 15451,
    categoryId: 2,
    itemName: "Tata 1mg CoQ 10 (Coenzyme 10) Capsules for Heart Health",
    itemPrice: "644",
    highlights: [
      "It supports heart and vascular health",
      "Promotes healthy cellular function",
      "Contains protein, vitamins and minerals",
      "Strong antioxidant which protects cells from damage",
    ],
    desc: {
      keybenefit: [
        "It supports heart and vascular health",
        "Helps prevent cell damage",
        "Promotes healthy heart and cellular function",
        "It may help prevent heart conditions such as heart failure, congestive heart failure, chest pain (angina), and high blood pressure",
      ],
      directions: [
        "Take one soft gel capsule daily after a meal or as suggested by a healthcare professional.",
      ],
      Safetyinfo: [
        "Protect from light and moisture",
        "This product is not intended to diagnose, treat, cure or prevent any disease",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/dj9v8xuxcpfoseulq96n.jpg",
  },
  {
    id: 12,
    categoryId: 2,
    itemName: "Omron HEM 7124-IN BP Monitor",
    itemPrice: "1940",
    highlights: [
      "Helps to detect blood pressure along with pulse rate",
      "Includes hypertension indicator",
      "Compromises of easy one-touch operations",
      "Provides quick, precise, and reliable results",
    ],
    desc: {
      keybenefit: [
        "Omron HEM-7124-IN BP Monitor is designed to track the blood pressure level of an individual. The machine comes with hypertension indicator and also keeps the memory of last reading.",
      ],
      directions: ["Use as per requirement or as directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ss1kepn3xokqa6kywtkq.jpg",
  },
  {
    id: 13,
    categoryId: 2,
    itemName:
      "Carbamide Forte Cold Pressed Flaxseed Oil 1000mg with Omega 3,6 & 9 825mg Softgel Capsule",
    itemPrice: "499",
    highlights: [
      "It helps maintain a healthy heart",
      "Used to strengthen the immune system",
      "Helps in maintaining the softness of the skin",
      "Used to prevent hair fall",
    ],
    desc: {
      keybenefit: [
        "Flaxseed oil offers a cleaner, more sustainable, plant-based source of omega-3 fatty acid 1000mg compared to fish oil supplements",
        "It helps strengthen the immune system",
        "It helps in maintaining a healthy digestive and cardiovascular system",
        "Helps to soothe skin irritation and softens rough skin",
      ],
      directions: [
        "Take one daily with a meal or as directed by your healthcare professional. ",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/nhqfb8zmstolcbamt82x.jpg",
  },
  {
    id: 14,
    categoryId: 2,
    itemName: "Jubilant Nutrihance UB Gold 150mg of CoQ10 Veg Softgel Caps",
    itemPrice: "540",
    highlights: [
      "Gluten-free and paraben-free",
      "It provides antioxidant support and may improve immunity",
      "It supports heart, joint and brain health",
    ],
    desc: {
      keybenefit: [
        "It is a dietary supplement that improves immune health and provides antioxidant support",
        "Coenzyme Q-10 is a fat-soluble, vitamin-like compound that helps in the production of cellular energy",
        "It serves as an antioxidant that defends the body against free radicals and promotes heart health",
        "It may reduce oxidative damage and inflammation and increase ATP production",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/va0s2aabkymu9fiwbevo.jpg",
  },
  {
    id: 15,
    categoryId: 2,
    itemName:
      "Orange Packets 1000mg Natural Vitamin C & Zinc Effervescent Tablet (15 Each) Orange",
    itemPrice: "667",
    highlights: [
      "Increases the activity of antibodies to boost the immune system",
      "It helps with faster wound healing",
      "Improves collagen production to reduce wrinkles",
    ],
    desc: {
      keybenefit: [
        "Zinc, a vital nutrient for the body, helps to improve immunity, keep blood sugar under check, improve severe acne and decrease heart disease risk",
        "It helps to enhance the body’s immunity, making it easier to help fight against infections",
        "The tablet acts as an antioxidant and helps strengthen the skin’s barriers",
        "It helps to heal the skin cells and depends on vitamin C levels in the body",
      ],
      directions: ["Use as directed on the label."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/rtfodjibnc07hakswqsb.jpg",
  },
  {
    id: 16,
    categoryId: 2,
    itemName:
      "Carbamide Forte Cold Pressed Flaxseed Oil 1250mg Softgel Capsule",
    itemPrice: "349",
    highlights: [
      "It is an immune system booster for a healthier heart",
      "Helps to keep the hair, skin and nails healthy",
      "Help hydrate your skin and supply the best-known nutrients to support hair growth and nail strength",
    ],
    desc: {
      keybenefit: [
        "Flaxseed oil offers a cleaner, more sustainable, plant-based source of omega-3 fatty acid 1000mg",
        "The cold-pressed flaxseed oil is carefully extracted from organic, non-GMO flax seeds without the use of hexane or added heat, helping to preserve the delicate structure of the omega-3s",
        "With natural sources of ALA and omega 3 fatty acids, research is finding that organic flaxseed oil can help you feel more energized by helping your heart work more efficiently and naturally",
        "The essential omega 3 fatty acids in flaxseed oil help hydrate your skin and supply the best-known nutrients to support hair growth and nail strength",
      ],
      directions: [
        "Take one softgel daily with a meal or as directed by your healthcare professional. ",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/xx0zp8n7relw30sh0jeu.jpg",
  },
  {
    id: 17,
    categoryId: 2,
    itemName: "Vitaminnica Neuro Force Veg Capsule",
    itemPrice: "959",
    highlights: [
      "Helps boost immunity",
      "Supports cardiovascular health",
      "Helps prevent cellular damage",
    ],
    desc: {
      keybenefit: [
        "The formulation helps to promote a better mood and maintain optimal health",
        "The capsules help to improve the function of the nervous and the immune system",
        "They support brain function and help improve cardiovascular health",
      ],
      directions: [
        "Use as directed on the label or as advised by the physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/8eef2b9bfc8e43618f3df2d384903949.jpg",
  },
  {
    id: 18,
    categoryId: 2,
    itemName: "Zingavita Omega 3 Fish Oil 1000mg Soft Gelatin Capsule",
    itemPrice: "249",
    highlights: [
      "Free from sugar, soy and gluten",
      "Promotes a healthy heart",
      "Promotes good cognitive health",
    ],
    desc: {
      keybenefit: [
        "It is free from sugar, soy and gluten",
        "It promotes a healthy heart",
        "It promotes good cognitive health",
        "It can help support eye health",
      ],
      directions: [
        "Daily 1 tablet after lunch or dinner. Do not take on an empty stomach.",
        "Zingavita supplements work best along with a healthy diet, regularly drinking water, and good sleep",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ivxygrk9z7qhpegk3zkd.jpg",
  },
  {
    id: 19,
    categoryId: 2,
    itemName: "Jubilant Nutrihance UB Gold 150mg of CoQ10 Veg Softgel Caps",
    itemPrice: "1085",
    highlights: [
      "Gluten-free and paraben-free",
      "It provides antioxidant support and may improve immunity",
      "It supports heart, joint and brain health",
    ],
    desc: {
      keybenefit: [
        "It is a dietary supplement that improves immune health and provides antioxidant support",
        "Coenzyme Q-10 is a fat-soluble, vitamin-like compound that helps in the production of cellular energy",
        "It serves as an antioxidant that defends the body against free radicals and promotes heart health",
        "It may reduce oxidative damage and inflammation and increase ATP production",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
        "Not to be used by children below 5 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ubd4j4r7oxr4lehax28k.jpg",
  },
  {
    id: 20,
    categoryId: 2,
    itemName: "Argipreg Granules",
    itemPrice: "1085",
    highlights: [
      "Promotes growth and development of the body",
      "It can boost athletic performance",
      "Supports cardiovascular and immune health",
    ],
    desc: {
      keybenefit: [
        "It helps improve blood circulation in the body by relaxing the blood vessels",
        "Proanthocyanidin promotes immune and cardiovascular function",
        "It helps improve high blood sugar levels and high blood pressure",
        "It promotes muscle development and supports athletic performance",
      ],
      directions: [
        "Use as directed on the label or as directed by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/o42s0ximi17m0gfzv13s.jpg",
  },

  // categoryId3 will starts from here {Stomach care}
  {
    id: 21,
    categoryId: 3,
    itemName: "Softovac-O Orange Powder",
    itemPrice: "134",
    highlights: [
      "Provides effective relief from constipation",
      "Regulates bowel movements and detoxifies the body",
      "Ayurvedic formulation helps user pass stool more effectively",
    ],
    desc: {
      keybenefit: [
        "Used as a bulking agent to help users pass stool more effectively",
        "Softovac Powder is also used for providing relief from symptoms of acidity and gas",
        "Cleanses the colon & detoxifies the body",
      ],
      directions: [
        "Pour 2 spoonfuls of Softovac powder into a glass",
        "Pour water into the glass and stir the mixture",
        "Make sure there are no lumps formed",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/vawxkyegilcudfeiifzs.png",
  },
  {
    id: 22,
    categoryId: 3,
    itemName: "WOW Life Science Probiotics Vegetarian Capsules",
    itemPrice: "639",
    highlights: [
      "This product may help build strong immunity",
      "It can promote healthy digestion",
      "It may maximise nutrient absorption",
    ],
    desc: {
      keybenefit: [
        "These capsules can help promote digestion and immunity",
        "It may aid in nutrient absorption",
        "It might assist in balancing the intestinal flora to help the gut absorb maximum nutrition from the food eaten",
      ],
      directions: [
        "Take 1 capsule 1-2 times daily, with water at meal times or as directed by your healthcare professional.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or nursing mothers, children below 18 years of age and individuals with known medical conditions should consult their healthcare professional before using this product",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/366edc098ac8498a91f672852d3c16d4.jpg",
  },
  {
    id: 23,
    categoryId: 3,
    itemName: "Kayam Tablet",
    itemPrice: "107",
    highlights: [
      "Formulated with potent Ayurvedic herbs",
      "Helps relieve chronic constipation",
      "Relieves acidity and gas",
    ],
    desc: {
      keybenefit: [
        "It helps improve gut mobility and bowel movements",
        "Provides effective relief from gas and flatulence",
        "Helps stimulate appetite and relieve intestinal disorders",
      ],
      directions: ["1 to 2 tablets at bedtime with normal or lukewarm water."],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or nursing mothers, children below 18 years of age and individuals with known medical conditions should consult their healthcare professional before using this product",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ejpoyifxqkviv9mcvyoh.jpg",
  },
  {
    id: 24,
    categoryId: 3,
    itemName:
      "Panchamrit Triphala Effervescent Tablet with Goodness of Triphala, Fennel & Prebiotics Lime",
    itemPrice: "399",
    highlights: [
      "Good source of prebiotics",
      "Aids digestion",
      "Regulate bowel movements",
    ],
    desc: {
      keybenefit: [
        "Triphala is high in antioxidants and anti-inflammatory properties that help relieve constipation and eliminates toxins from your body",
        "It helps regulate the metabolism and is a good source of prebiotics that improves gut health",
        "Helps stimulate appetite and relieve intestinal disorders",
      ],
      directions: ["One tablet per day or as directed by the physician"],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Use under medical supervision",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/52023e21fc0e4731905d48009096022c.jpg",
  },
  {
    id: 25,
    categoryId: 3,
    itemName: "Gynoveda Anasid Fast Relief Acidity Syrup (200ml Each) Rose",
    itemPrice: "299",
    highlights: ["Reduces heartburn", "Relieves acidity", "Improves digestion"],
    desc: {
      keybenefit: [
        "Amla is traditionally known to balance acid levels in the stomach by turning them into harmless alkaline form",
        "Shwet kamal is a proven formula to reduce heartburn",
        "Ancient ayurvedic scripture ‘charak samhita’ and 100s of clinical research papers found herbs like yashtimadhu, kamdudha ras and giloy to be powerful ingredients for reducing excessive pitta naturally",
        "A powerful blend of 12 ayurvedic herbs helps you get relief from acidity naturally without consuming any synthetic chemicals",
      ],
      directions: [
        "Consume daily 10 ml syrup before breakfast and 10 ml before dinner.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Use under medical supervision",
        "Read the label carefully before use",
        "Keep out of reach of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/f87703ead5904671aca37455f380036b.jpg",
  },
  {
    id: 26,
    categoryId: 2,
    itemName: "Zandu Nityam Churna",
    itemPrice: "88",
    highlights: ["Reduces heartburn", "Relieves acidity", "Improves digestion"],
    desc: {
      keybenefit: [
        "Nityam Churna is an Ayurvedic laxative, enriched with seven laxative herbs like castor oil, triphala and saunf. This herbal composition increases the movement of the intestines, improves digestion and potentates adrenergic function.",
        "Nityam Churna is indicated for relief from constipation, acidity, nausea and indigestion. It cleanses, lubricates and moisturizes intestinal walls naturally, ensuring regular bowel movements.",
      ],
      directions: [
        "Add 1-2 teaspoons of Nityam Churna to a glass of water,Stir gently unless the powder dissolves well.Consume immediately.",
        "Nityam Churna powder should be consumed during bedtime. Individual results may vary. ",
      ],
      Safetyinfo: ["It is not recommended during pregnancy."],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/wv7eescusjzqm9oxjiht.jpg",
  },
  {
    id: 27,
    categoryId: 3,
    itemName: "Digene Acidity & Gas Relief Tablet Mint",
    itemPrice: "19",
    highlights: [
      "Helps to relieve bloating, belching, and gas",
      "Helps to relieve the feeling of discomfort in the stomach",
      "Helps to treat heartburn (acidity) and indigestion",
    ],
    desc: {
      keybenefit: [
        "Neutralizes excess stomach acid and protects the lining of the stomach from irritation",
        "Helps to relieve symptoms of extra gas such as, bloating and feeling of discomfort in the stomach",
        "Helps to reduce the overall acid level in the stomach",
      ],
      directions: [
        "Ideally, adults are advised to chew or suck 2-4 tablets, after meals, preferably at bedtime or as advised by your physician. Children can take the tablets as per their doctor’s recommendation.  ",
      ],
      Safetyinfo: ["It is not recommended during pregnancy."],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/n1t9q5dstymk2xdknbd7.jpg",
  },
  {
    id: 28,
    categoryId: 3,
    itemName: "Polycrol Antacid Gel Mint Xpress Relief Sugar-Free",
    itemPrice: "180",
    highlights: [
      "For Polycrol the action starts in 10 seconds",
      "Provides an immediate cooling effect",
      "Helps to treat heartburn (acidity) and indigestion",
    ],
    desc: {
      keybenefit: [
        "The action starts in 10 secs*",
        "Provides immediate cooling effect*",
        "It is sugar-free with a mint flavour",
      ],
      directions: [
        "2 teaspoonfuls (10 ml) after meals and at bedtime, or as advised by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of the reach of children",
        "Store in a cool dry place",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/rl7y3bg1y4g1ziib92cc.jpg",
  },
  {
    id: 29,
    categoryId: 3,
    itemName: "Dabur Hajmola Regular",
    itemPrice: "55",
    highlights: [
      "Helps in the digestion process",
      "Provides gastrointestinal functions",
      "Enhances the digestive functions",
    ],
    desc: {
      keybenefit: [
        "Black pepper is a gastrointestinal stimulant",
        "Long pepper and black salt have carminative properties",
        "Ginger is a powerful digestive tonic",
        "Lemon is a digestive stimulant",
        "Cumin seeds are antispasmodic",
      ],
      directions: ["Read the label carefully before use"],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the daily recommended dosage",
        "Store in a cool, dry place, away from direct heat and sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/bxbeojn9xappfjrircbb.jpg",
  },
  {
    id: 30,
    categoryId: 3,
    itemName: "Cremaffin Constipation Relief Liquid Mixed Fruit",
    itemPrice: "279",
    highlights: [
      "Acts promptly and provides effective relief from constipation",
      "Softens the stool and makes it easy to pass",
      "Lubricates the intestinal lining which helps in easy passing of the stools",
    ],
    desc: {
      keybenefit: [
        "Provides gentle and effective relief from constipation",
        "Provides prompt defecation in around 8 hours",
        "Helps in softening the stool by drawing water through osmosis",
        "Promotes healthy bowel movement and improves bowel function",
        "Suits kids, adults as well as older people and is sugar-free",
      ],
      directions: [
        "It should be taken as advised by your doctor. However, the best time to take this syrup is at bedtime, preferably with water and if necessary, again in the morning.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the daily recommended dosage",
        "Store in a cool, dry place, away from direct heat and sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/fifua5s1kcpidqpikgbd.jpg",
  },
  // categoryId4 will starts from here {Liver Care}
  {
    id: 31,
    categoryId: 4,
    itemName:
      "Tata 1mg Milk Thistle Veg Capsule for Liver Detox, 70% Silymarin with Dandelion & Ginger, Supports Liver Detox & Prevents Fatty Liver",
    itemPrice: "426",
    highlights: [
      "Useful in  alcoholic and non-alcoholic fatty liver problems",
      "Supports healthy liver functions ",
      "Helps in reducing excess fat stored in the liver",
    ],
    desc: {
      keybenefit: [
        "Helps in liver detoxification",
        "Has anti-inflammatory properties that help reduce liver inflammation",
        "Helps to improve liver functions",
        "Contains antioxidants that protect the liver from damage caused by oxidative stress",
      ],
      directions: [
        "1 capsule per day or as suggested by the healthcare practitioner",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the daily recommended dosage",
        "Store in a cool, dry place, away from direct heat and sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/2b1dea512d474ab48100f1969cb9f6e8.jpg",
  },
  {
    id: 32,
    categoryId: 4,
    itemName: "Himalaya Liv. 52 Tablet",
    itemPrice: "141",
    highlights: [
      "Helps to protect the liver against hepatotoxins",
      "Guards the liver against jaundice and hepatitis A & B",
      "Stimulates the overall growth and appetite of the body",
    ],
    desc: {
      keybenefit: [
        "Facilitates the rapid elimination of acetaldehyde, which is responsible for causing hangovers, and protects from alcohol-induced hepatic damage",
        "Lowers the effect of lipotropic effect in chronic alcoholism and prevents fatty infiltration of the liver",
        "Protects the liver from further damage and promotes its optimal functioning",
      ],
      directions: ["As directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the daily recommended dosage",
        "Store in a cool, dry place, away from direct heat and sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/m4pgzop080oaibzxwxtc.jpg",
  },
  {
    id: 33,
    categoryId: 4,
    itemName:
      "Zeroharm Sciences Vegan Omega-DHA Algae Based Vegan Capsule for Brain, Heart, Joint and Muscle Support",
    itemPrice: "871",
    highlights: [
      "Complete vegan omega-DHA (marine algae)",
      "It is suitable for heart, brain and eye health",
      "It may prevent fatty liver",
    ],
    desc: {
      keybenefit: [
        "It may promote eye, brain, heart and joint health",
        "The zero harms omega contains algae as the main source of DHA, and hence it is vegan and has a higher absorption",
        "It is algae movie-based omega",
        "Algae in this capsule is non-toxic and contamination-free",
      ],
      directions: ["As directed by the physician."],
      Safetyinfo: [
        "This is a nutraceutical product and is not intended to diagnose, prevent, treat or cure any disease",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/hml2wpvmk5faa0vrms4k.jpg",
  },
  {
    id: 34,
    categoryId: 4,
    itemName: "Dr. Biswas Good Health Capsule",
    itemPrice: "210",
    highlights: [
      "Stimulates the appetite",
      "Helps in protein synthesis resulting in weight gain",
      "Improves the functioning of the liver",
    ],
    desc: {
      keybenefit: [
        "Withania somnifera",
        "Hemidesmus indicus",
        "Vitis vinifera",
        "Asparagus racemosus",
      ],
      directions: ["As directed by the physician."],
      Safetyinfo: [
        "This is a nutraceutical product and is not intended to diagnose, prevent, treat or cure any disease",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/sp0ulunikdslhjepd5gr.jpg",
  },
  {
    id: 35,
    categoryId: 4,
    itemName: "Himalaya Liv.52 Syrup",
    itemPrice: "210",
    highlights: [
      "It protects the liver from chemically-induced hepatotoxicity",
      "Helps restore liver function",
      "Improves overall digestive health",
      "Improves appetite and promotes weight gain",
    ],
    desc: {
      keybenefit: [
        "Chicory is a potent antioxidant that protects the cell against alcohol toxicity and helps protect against free radical damage",
        "The caper bush has antioxidant and hepatoprotective properties that improve the functional efficiency of the liver",
        "It improves loss of appetite, enhances the digestive process and promotes weight gain",
      ],
      directions: [
        "Please consult a healthcare professional to prescribe the dosage that best suits the condition.",
      ],
      Safetyinfo: [
        "This is a nutraceutical product and is not intended to diagnose, prevent, treat or cure any disease",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/z4x6mnuiyhfdjhb0qf3w.jpg",
  },
  {
    id: 36,
    categoryId: 4,
    itemName: "SBL Liv T Tonic",
    itemPrice: "130",
    highlights: [
      "It helps manage various liver conditions like jaundice, hepatitis and indigestion",
      "It combats liver disorders caused by chronic gastric indiscretion, viral and bacterial infection, drugs, chemicals and alcohol",
      "It rejuvenates the hepatic cells, detoxifies the liver and promotes the flow of bile",
      "It helps to provide relief in case of lack of appetite",
    ],
    desc: {
      keybenefit: [
        "It performs many essential functions like aiding digestion and detoxifying poisonous substances into non-poisonous ones",
        "It rejuvenates the hepatic cells, detoxifies the liver and promotes the flow of bile",
        "It helps to provide relief in case of lack of appetite",
      ],
      directions: [
        "Adults: Two teaspoonfuls three times a day half an hour after meals or as prescribed by the physician",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/syzqdci2dlkskg6a7swm.jpg",
  },
  {
    id: 37,
    categoryId: 4,
    itemName: "Humming Herbs The Detox",
    itemPrice: "435",
    highlights: [
      "Cleanses the liver",
      "Reduces bloating",
      "Prevents indigestion",
      "Keeps the tummy stabilised",
    ],
    desc: {
      keybenefit: [
        "This product helps manage the health of the liver",
        "It is also beneficial for blood sugar levels",
        "This formula helps control cholesterol levels",
      ],
      directions: [
        "Take one capsule twice a day before food or as directed by your healthcare professional.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/788188b0b96f4a8d90bc429156b8fac9.jpg",
  },
  {
    id: 38,
    categoryId: 4,
    itemName: "Aimil Amlycure DS Syrup",
    itemPrice: "258",
    highlights: [
      "Desired strength liver corrective and protective drug",
      "Enriched with potent bioactive constituents",
      "Normalises deranged LFT parameters",
      "Boosts metabolism",
    ],
    desc: {
      keybenefit: [
        "Enriched with the highest number of synergistically acting herbal extracts in optimal concentration (desired strength) to provide therapeutic effect during treatment",
        "It comprehensively activates the complete digestive system from appetite, digestion, assimilation, and metabolism by toning the liver. It also boosts immunity",
        "The one-stop formula for effective treatment of liver diseases such as poor liver functions, fatty liver, alcohol-induced liver damage, hepatocytes degeneration, etc.",
      ],
      directions: ["For adults: 2-3 teaspoonfuls thrice a day"],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/qc3fu8vdrms4az0wfjhe.jpg",
  },
  {
    id: 39,
    categoryId: 4,
    itemName: "Dhootapapeshwar Arogyavardhini Bati",
    itemPrice: "325",
    highlights: [
      "Improves quality of skin",
      "Supports functioning of the liver",
      "Alleviate symptoms of pain and fever",
    ],
    desc: {
      keybenefit: [
        "It can help to support the functioning of the liver",
        "Helps to improve the quality of skin and makes the skin healthier",
        "Helps to alleviate the symptoms of fever and reduce body temperature",
      ],
      directions: [
        "Take Dhootapapeshwar Arogyavardhini Bati as directed by the physician.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/ojyohfyqi9bd8hl72kod.jpg",
  },
  {
    id: 40,
    categoryId: 4,
    itemName: "Bakson's Biocombination 7 Tablet",
    itemPrice: "557",
    highlights: [
      "Helps with liver and kidney functions",
      "Relieves cramps and sleeplessness",
      "Aids in regulating sugar levels",
    ],
    desc: {
      keybenefit: [
        "Increased micturition, excessive thirst & dryness, cramps, prostration and sleeplessness",
        "Helps better assimilation of glucose and kidney and liver functions are also improved",
        "Improves urination with less sensation of weakness and pain in the region of kidneys when lifting or blowing the nose",
      ],
      directions: [
        "Read the label carefully or as directed by your physician.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/dgbwegdi582n5g7pv9mm.jpg",
  },
  // categoryID:5 starts here {Bone Joint muscles}
  {
    id: 41,
    categoryId: 5,
    itemName:
      "Tata 1mg Calcium + Vitamin D3, Zinc, Magnesium and Alfalfa Tablet, Joint Support, Bones Health, Immunity & Energy Support",
    itemPrice: "277",
    highlights: [
      "Improves bone density, bone strength and muscle functions",
      "It may help lower the risk of osteoporosis",
      "Helps to maintain strong bones and improve immunity",
    ],
    desc: {
      keybenefit: [
        "It is a dietary supplement that supports bone and joint health",
        "It promotes mobility and flexibility of joints",
        "Calcium citrate malate boosts collagen synthesis, aids muscle function, helps build muscle strength and enhances recovery",
      ],
      directions: [
        "Take two tablets daily or as prescribed by your medical practitioner.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/gc3u9gfc331wtsipnljl.jpg",
  },
  {
    id: 42,
    categoryId: 5,
    itemName: "Tata 1mg Vitamin D3 Capsule",
    itemPrice: "277",
    highlights: [
      "Helps in better calcium absorption in the body ",
      "Helps reduce fatigue, stress and muscular pains",
      "Can help reduce the risk of osteoporosis",
      "Helps prevent vitamin D deficiency ",
    ],
    desc: {
      keybenefit: [
        "Facilitates the absorption of calcium and phosphorus in the body",
        "Essential for the development and growth of bones and teeth ",
        "It helps reduce the risk of osteoporosis and prevent bone loss and fractures",
      ],
      directions: [
        "Take one softgel capsule daily or use as suggested by your healthcare professional ",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/d3fe87a68c7c4b27a0061dea72209a76.jpg",
  },
  {
    id: 43,
    categoryId: 5,
    itemName:
      "Tata 1mg Senior 50+ Multivitamin & Multimineral Veg Tablet with Zinc, Vitamin C, Calcium and Vitamin D, Supports Immunity, Strength & Overall Health",
    itemPrice: "397",
    highlights: [
      "Fulfils the micronutrient needs ",
      "Helps enhance memory and delays ageing",
      "Supports eye and heart health",
      "Aids in improving joint mobility and flexibility",
    ],
    desc: {
      keybenefit: [
        "Helps to enhance memory",
        "Aids in improving the immunity level",
        "Supports eye and heart health",
      ],
      directions: [
        "One tablet per day or as directed by the healthcare practitioner ",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/klpj2khvaphkvpqmchui.jpg",
  },
  {
    id: 44,
    categoryId: 5,
    itemName: "Flexiqule Capsule, Strength & Overall Health",
    itemPrice: "397",
    highlights: [
      "Clinically tested solution that reduces joint stiffness and pain with no side effects seen",
      "Supports normal joint function, mobility and flexibility",
      "Natural formulation packed with ‘Phyto-actives’ (most powerful active ingredients in medicinal plants) of ginger and boswellia",
    ],
    desc: {
      keybenefit: [
        "Helps to enhance memory",
        "Aids in improving the immunity level",
        "Supports eye and heart health",
      ],
      directions: [
        "One tablet per day or as directed by the healthcare practitioner ",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/ysgxiaa0janhe8vg7vx5.png",
  },
  {
    id: 45,
    categoryId: 5,
    itemName: "Iron Lifters Glutamine Powder",
    itemPrice: "1540",
    highlights: [
      "Contains essential amino acid",
      "Can help in protein synthesis",
      "May increase muscle mass",
      "Speeds up muscle recovery after workout",
    ],
    desc: {
      keybenefit: [
        "This product can increase the response time of the immune system during workout sessions",
        "It may help in protein synthesis that increases muscle mass and strength",
        "This product is vegan-friendly",
      ],
      directions: [
        "Use the scoop provided and one scoop to a glass of 200-250 ml of water or a drink, fruit juice, or protein shake of your choice",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/faxrfoyl373kic256ucc.jpg",
  },
  {
    id: 46,
    categoryId: 5,
    itemName: "Dr Ortho Knee Cap",
    itemPrice: "299",
    highlights: [
      "Made with cotton lycra fabric",
      "Provides a warm and mild compression",
      "Skin-friendly",
      "Speeds up muscle recovery after workout",
    ],
    desc: {
      keybenefit: [
        "It is made with cotton lycra fabric",
        "Specially designed to provide support to the knee",
        "It helps provide a warm and mild compression to the knee joint",
      ],
      directions: ["use as directions by doctor"],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Pregnant or lactating or prone to any food allergy or under any medical condition or undergoing any treatment, consult the health care professional",
        "Read the label carefully before use",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/pbt0c9o6a1lmmbznusnl.jpg",
  },
  {
    id: 47,
    categoryId: 5,
    itemName:
      "Blackmores Shine Power D3 Capsule for Healthy Teeth, Stronger Bones & Boosted Immunity",
    itemPrice: "1007",
    highlights: [
      "Helps enhance the function of immune cells to help fight off infections",
      "Vitamin D3 is known to help boost the absorption of calcium and phosphate",
      "Improves muscle strength ",
    ],
    desc: {
      keybenefit: [
        "Enriched With Natural Vitamin D3: Shine Power uses natural Vitamin D3 in the form of Cholecalciferol. It helps assist calcium absorption. Lower levels of calcium in the body lead to other health issues.",
        "Vitamin D3 is known to support healthy immune system function and healthy bone development. ",
        "It helps support joint and bone growth. It also helps maintain healthy bone and muscle strength. ",
      ],
      directions: ["Take 1 tablet once a day"],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/nq89kt3btuq60dlkvleq.jpg",
  },
  {
    id: 48,
    categoryId: 5,
    itemName: "OneLife 100% Plant Protein Powder Mocha",
    itemPrice: "1534",
    highlights: [
      "Vegan, sugar-free and soy-free",
      "Rrich in antioxidants and easy to digest",
      "A unique blend of 4 high-quality proteins",
    ],
    desc: {
      keybenefit: ["Pea protein", "Brown rice protein", "Quinoa protein"],
      directions: [
        "Mix one scoop (34g) in 250-300 ml of milk/water/smoothies/any beverage of choice. Shake well and consume or substitute flour in your favourite baking recipes.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
        "This product is not intended to diagnose, prevent, treat or cure any disease",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/sv8bsieatprm3fg2cgyi.jpg",
  },
  {
    id: 49,
    categoryId: 5,
    itemName: "Jiva Pain Calm Oil",
    itemPrice: "199",
    highlights: [
      "Promotes flow of blood to the affected area and eases the pain",
      "It has natural anti-inflammatory properties which help to reduce swelling",
      "Acts as a pain reliever that helps to ease stiffness and relax muscles",
    ],
    desc: {
      keybenefit: [
        "Relieves muscles pain, bloating and inflammation in joints and muscles",
        "Provide relief in headache, increases alertness and concentration is boosted",
        "Works wonder for joint pain, back pain, muscle pain, neck or shoulder pain and reduce muscle stiffness and soreness",
      ],
      directions: [
        "Warm the oil and gently apply to the affected parts and massage in a circular motion",
        "Massage by applying gentle pressure on the affected areas",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/zmsryggcuruy3gwxwztm.jpg",
  },
  {
    id: 50,
    categoryId: 5,
    itemName: "Hiral Health Boheal Tablet",
    itemPrice: "329",
    highlights: [
      "It enhance the absorption of calcium and phosphorus in the body",
      "It prevent from osteoporosis and bone weakness",
      "Helps to reduce cortisol level and inflammation",
    ],
    desc: {
      keybenefit: [
        "It helps to reduce bone,joint pain and prevent metabolic syndrome",
        "It consist of medicinal herbs prevent bone weakness,stress,anxitey and psycological disorder",
        "Ashwagandha helps to reduce cortisol level and inflammation",
      ],
      directions: [
        "One tablet daily preferably after a meal or as directed by the dietician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool dry place away from direct sunlight",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/a6b00a115352473eb3998c0e7266866a.jpg",
  },

  // categoryId:6 starts here eye { eye care}
  {
    id: 51,
    categoryId: 6,
    itemName:
      "Zingavita Sharp Eye Multivitamin Gummies for Kids (with Essential Eye Vitamins) Strawberry Mix",
    itemPrice: "249",
    highlights: [
      "Supports eye health",
      "Improves sleep quality",
      "Helps in brain development",
    ],
    desc: {
      keybenefit: [
        "The yummy gummies are packed with meticulously sourced nutrients such as DHA, lutein, zeaxanthin, vitamin A, C and E",
        "These gummies for eyes help protect kid’s eyes from high energy blue light emanating from digital screens",
        "Improves sleep quality",
        "Promotes healthy brain development",
      ],
      directions: [
        "Children 5+ years old: Chew 2 gummies daily or as directed.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/gt6ij71dfd3k9egrfia3.jpg",
  },
  {
    id: 52,
    categoryId: 6,
    itemName: "Lubistar 1% Eye Drop",
    itemPrice: "128",
    highlights: [
      "Dry eyes is a condition in which your eyes do not produce enough tears to keep them moist. It can be caused by sitting in front of the computer for a long time, certain medications or environmental conditions. Lubistar 1% Eye Drop adds moisture to your eyes and keeps them lubricated. This gives relief from burning sensation and discomfort due to dryness of the eyes. If you wear soft contact lenses, you should remove them before applying Lubistar 1% Eye Drop.",
    ],
    desc: {
      keybenefit: [
        "Lubistar 1% Eye Drop is a prescription medicine used to treat symptoms of dry eyes. It lubricates the eyes helps in maintaining the moisture of the eyes. This way it provides temporary relief from burning and discomfort caused by dry eyes. It also reduces redness and swelling of the eye.",
        "Lubistar 1% Eye Drop is to be used only in the affected eye. Use it in the dose and duration as advised by the doctor. Read the label carefully for instruction before you use the medicine. Wash your hands before using this medicine. Do not use too much or too little. Use it in the exact dose as prescribed by the doctor or as instructed in the label.",
        "Use of this medicine may cause burning sensation, stinging, and irritation at the application site. These are usually temporary and resolve with time. However, if they persist or get worse, inform your doctor. In case of accidental contact with your ears, nose, or mouth, immediately rinse it with water.",
      ],
      directions: [
        "Children 5+ years old: Chew 2 gummies daily or as directed.",
      ],
      Safetyinfo: [
        "Your doctor has prescribed Lubistar 1% Eye Drop to reduce dryness in the eyes.",
        "Keep out of reach of the children",
        "Stinging sensation may occur for 1-2 minutes. Notify your doctor if it persists for longer.",
        "Wait for at least 5-10 minutes before delivering the next medication in the same eye to avoid dilution of this medicine.",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_480,h_480/a_ignore,w_480,h_480,c_fit,q_auto,f_auto/hp7slixc8rawaogqodid.jpg",
  },
  {
    id: 53,
    categoryId: 6,
    itemName: "Itone Eye Drop",
    itemPrice: "55",
    highlights: [
      "Prevents further damage by keeping the eye lubricated",
      "Helps treat infection and irritation of the conjunctiva",
      "Helps in healing and preventing rejection of the donor tissue",
    ],
    desc: {
      keybenefit: [
        "Itone Eye Drop relieves dryness and irritation, promoting comfort",
        "Itone Eye Drop increases comfort by reducing the feeling of a surface scratch and flushing out any residual contaminating or injurious particles",
        "Itone Eye Drops are also useful in pink eyes, conjunctivitis, swollen eyelid bump, itching and burning sensation in the eyes",
      ],
      directions: ["Use as directed on the label."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Do not exceed the recommended dosage",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/xn0n7khy5vzfnqkxwfn8.jpg",
  },
  {
    id: 54,
    categoryId: 6,
    itemName: "Himalaya Ophthacare Eye Drop",
    itemPrice: "69",
    highlights: [
      "Relieves dry eyes, eyestrain, swelling, redness and inflammation",
      "Contains anti-inflammatory action",
      "Keeps the eyes safe from infection and allergic disorders",
    ],
    desc: {
      keybenefit: [
        "Helps to keep the eyes safe from infections and allergic disorders",
        "Its cooling and antibacterial effects soothe the eyes in case of irritation",
        "Facilitates the quick healing of minor wounds",
      ],
      directions: ["Use as directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/bwajzknm1li1zhcb7vii.jpg",
  },
  {
    id: 55,
    categoryId: 6,
    itemName: "Zingavita Omega 3 Fish Oil 1000mg Soft Gelatin Capsule",
    itemPrice: "249",
    highlights: [
      "Free from sugar, soy and gluten",
      "Promotes a healthy heart",
      "Promotes good cognitive health",
      "Enhanced absorption and bioavailability",
    ],
    desc: {
      keybenefit: [
        "It is free from sugar, soy and gluten",
        "It promotes a healthy heart",
        "It promotes good cognitive health",
        "It also supports strong muscle and bone health",
      ],
      directions: [
        "Daily 1 tablet after lunch or dinner. Do not take on an empty stomach.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ivxygrk9z7qhpegk3zkd.jpg",
  },
  {
    id: 56,
    categoryId: 6,
    itemName: "I-Site AF Capsule",
    itemPrice: "229",
    highlights: [
      "Protects your eyes from the damage caused by free radicals and UV rays",
      "Manages the risk of ARMD (age-related macular degeneration)",
      "Effective in managing skin-related concerns",
    ],
    desc: {
      keybenefit: [
        "I-site capsule helps filter the high-energy blue light exposure to the eye",
        "Boosts the immune system, prevents cell damage and reduces eye inflammation",
        "The capsule is used to manage eye-related concerns, such as ARMD, glaucoma, ocular pressure, and cataract",
      ],
      directions: [
        "Take one capsule daily for adults as directed by your healthcare professional.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uc8kjna18khpskowgxnx.jpg",
  },
  {
    id: 57,
    categoryId: 6,
    itemName: "Renu Fresh Solution",
    itemPrice: "608",
    highlights: [
      "Helps fight germs and disinfect the lenses",
      "Moisturises the lenses and prevents them from drying out",
      "Can be used to store, clean and rinse contact lenses",
    ],
    desc: {
      keybenefit: [
        "It helps kill germs and disinfect the lenses",
        "Creates a cushion of moisture between the eye and the lenses",
        "Provides sustained wettability and conditioning to the eye",
      ],
      directions: [
        "Place the solution in your contact case",
        "Insert your contact lenses gently into the case",
        "Replace the contact solution after each use",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/mwsb8nuqe6178r1clzlp.jpg",
  },
  {
    id: 58,
    categoryId: 6,
    itemName: "Lutivit NF Soft Gelatin Capsule",
    itemPrice: "190",
    highlights: [
      "It can improve eye health",
      "It may enhance skin health",
      "It has antioxidant properties",
    ],
    desc: {
      keybenefit: [
        "Beta-carotene is a provitamin of Vitamin A which can help improve vision and improve skin health",
        "Lutein may help support eye functions",
        "It has antioxidant and anti-inflammatory properties",
      ],
      directions: ["Take one capsule daily or as directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/iylaaw0ytq3kisjgx7oc.jpg",
  },
  {
    id: 59,
    categoryId: 6,
    itemName: "Dr. Reckeweg R78 Eye Care Drop",
    itemPrice: "251",
    highlights: [
      "Relieves eye pain and discomfort",
      "Prevents irritation in the mucous membrane of the eye",
      "Reduces inflammation in upper eyelid",
    ],
    desc: {
      keybenefit: [
        "Dr. Reckeweg R78 Eye Care Drop is beneficial for relieving eye-related issues such as eyestrain and conjunctivitis",
        "It helps in reducing irritation in the mucous membrane, ulcerous cornea, and swelling of eyelids with discharge",
        "It contains Euphrasia which helps in reducing eye strain, and manages intraocular pressure, lacrimation and blepharitis",
      ],
      directions: [
        "Use as directed on the label or as advised by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/rj8njkvga0vodhv42dev.jpg",
  },
  {
    id: 60,
    categoryId: 6,
    itemName: "Wellman 70+ Health Supplement for Men Tablet",
    itemPrice: "356",
    highlights: [
      "Pumpkin seed extract lowers urinary dysfunction and improves overactive bladder",
      "Vitamin C lowers the risk of Coronary Heart Disease and improves immune function",
      "Lipoic acid restores age-associated impairment of brain energy metabolism",
    ],
    desc: {
      keybenefit: [
        "Wellman 70+ contains thiamine (vit.B1), copper and iron which contribute to normal energy release",
        "Vitamin B6 and B12 are included as they contribute to normal red blood cell formation plus iron contributes to normal formation of red blood cells and hemoglobin, the substance that helps to transport oxygen around the body",
        "Wellman 70+ also includes vitamin C, B6, B12, and D plus minerals zinc and iron which contribute to the normal function of the immune system",
      ],
      directions: [
        "One tablet per day with or immediately after your main meal. Swallow with a full glass of water or a cold drink. Wellman should only be taken on a full stomach.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place",
        "Keep it away from the reach of children",
        "Consult your healthcare professional in case you are pregnant, lactating or taking any medication",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ychrjptrenqpfjo4dzvj.jpg",
  },

  // categoryID:7 starts here {Kidney}
  {
    id: 61,
    categoryId: 7,
    itemName: "Nepro HP Powder Vanilla Toffee",
    itemPrice: "1020",
    highlights: [
      "Used by pre and post kidney transplant patients with elevated calorie and protein needs",
      "Useful for hospitalized patients with acute or chronic kidney disease",
    ],
    desc: {
      keybenefit: [
        "Suitable for patients with non-dialyzed chronic kidney disease patients with elevated calorie and protein needs",
        "Helps pre and post kidney transplant patients with elevated calorie and protein needs, hospitalized patients with acute or chronic kidney disease",
        "It is high in calories and protein (19.2g/237ml serving) which helps to meet the nutritional needs and replace protein lost during dialysis",
      ],
      directions: [
        "To prepare 237ml serving providing 446kcal, pour 167ml of clean, sterile water (room temperature or warm (<350C)) in a glass and gradually add 10 level scoop (enclosed) or 89g of powder while stirring and mix until dissolved. Can be given orally or by tube feeding as per physician's/ dietitian's advice.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/wuxk6kilycwu0swrc9yp.jpg",
  },
  {
    id: 62,
    categoryId: 7,
    itemName: "Himalaya Cystone Tablet",
    itemPrice: "152",
    highlights: [
      "Contains diuretic, demulcent, and antimicrobial actions ",
      "Helps to treat and prevent the formation of kidney stones ",
      "Provides relief in the case of burning micturition (urination)",
    ],
    desc: {
      keybenefit: [
        "As a diuretic, the herb helps to flush out small stones and gravel along with urine",
        "Shilapushpa (Didymocarpus pedicellata) prevents the formation of urinary stone and helps dissolve kidney stones",
        "It can be used as an adjuvant in chronic UTI, painful urination or blood present in urine and burning micturition (urination)",
      ],
      directions: ["Use as directed by the physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/ky7nvrfdcdgh6nlen7do.jpg",
  },
  {
    id: 63,
    categoryId: 7,
    itemName: "Lobun Forte Capsule",
    itemPrice: "849",
    highlights: [
      "Useful in case of Uremic detoxification and Chronic Kidney diseases",
      "Helps to neutralize the uremic toxins",
      "Helps to control the survival of putrefying bacteria in the colon",
    ],
    desc: {
      keybenefit: [
        "Lobun forte contains streptococcus thermophilus that is the major probiotic and used for its capacity to neutralize the uremic toxins like creatinine, urea and others",
        "Lobun forte is used because of pH lowering capability, which reduces the survival of other putrefying bacteria in the colon",
        "Lobun forte also increases the permeability of colon which further increases the toxin excreation",
      ],
      directions: [
        "Take Lobun Forte Capsule orally, twice a day or as directed by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/paibgfydhxnssgqltrfe.jpg",
  },
  {
    id: 64,
    categoryId: 7,
    itemName: "Swisse Ultiboost High Strength Cranberry 25000mg Capsule",
    itemPrice: "961",
    highlights: [
      "Prevents urinary tract infections",
      "It helps in keeping the urinary bladder healthy",
      "Is rich in antioxidants and help fight free-radical damage to cells through the presence of flavonols",
    ],
    desc: {
      keybenefit: [
        "The cranberry capsules contain unique powered pacran, a powdered form of the cranberry fruit that ensures every part of the fruit is used",
        "Daily intake of these cranberry capsules help fight free-radical damage to cells through the presence of flavonols, which have antioxidant properties",
        "These capsules assist in reducing bacterial adhesion to the urinary tract",
      ],
      directions: [
        "One capsule daily, during or immediately after a meal, or as recommended by a healthcare professional.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/kokziptrbu8pgg86xpye.jpg",
  },
  {
    id: 65,
    categoryId: 7,
    itemName: "Dabur Chandraprabha Vati",
    itemPrice: "127",
    highlights: [
      "Helps relieve urinary tract problems",
      "Used for treating indigestion",
      "Increases strength in the body",
    ],
    desc: {
      keybenefit: [
        "It is helpful in treating urinary tract infections as well as difficulty in urinating",
        "It helps in the treatment of urinary calculi",
        "Used in the treatment of indigestion and increases the body's strength",
      ],
      directions: ["Take 2 tablets twice a day or as directed by a physician."],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/sx5dxobxchlrntmrk5v4.jpg",
  },
  {
    id: 66,
    categoryId: 7,
    itemName: "Patanjali Divya Shudh Shilajeet (R.T.)",
    itemPrice: "110",
    highlights: [
      "Useful in maintaining a healthy blood pressure level",
      "Helps to strengthen nerves and muscles",
      "Helps to boost strength and energy",
    ],
    desc: {
      keybenefit: [
        "Beneficial for the nervous system diseases of male reproductive organs and urinary system",
        "Improves the quality of the sperms and treats male infertility",
        "It improves mental as well as physical endurance of the body",
      ],
      directions: [
        "Take 2 tablets a day, post meals with lukewarm water or as directed by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/u3eysaqfuaccqagtzj6b.jpg",
  },
  {
    id: 67,
    categoryId: 7,
    itemName: "SBL Arsenicum Album Dilution 30 CH",
    itemPrice: "86",
    highlights: [
      "Helps in treating the increased temperature with marked periodicity",
      "Provides support in difficult, suffocating, and wheezing respiration with dry cough and spitting of blood with sputum",
      "Useful in treating respiratory ailments such as breathing issues",
    ],
    desc: {
      keybenefit: [
        "Helps in treating respiratory ailments such as cough, wheezing, and breathing difficulties",
        "Useful in treating fever and weakness caused due to infections",
        "Relieves anxiety and stress related to recurrent health problems",
      ],
      directions: [
        "Take 2-3 drops of dilution in 1 teaspoon of water thrice a day or as directed by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/ergrpppp0crrivsypqj9.png",
  },
  {
    id: 68,
    categoryId: 7,
    itemName: "Baidyanath (Nagpur) Gokshuradi Guggulu",
    itemPrice: "135",
    highlights: [
      "The diuretic and anodyne nature of Gokshuradi Guggulu soothes painful urination and improves kidney functions",
      "The mild anti-bacterial and anti-microbial properties of Baidyanath Gokshuradi Guggulu treat UTIs (urinary tract infections)",
    ],
    desc: {
      keybenefit: [
        "Treats gout, osteoarthritis and knee pain",
        "The diuretic and anodyne nature of Gokshuradi Guggulu soothes painful urination and improves kidney functions",
        "The mild anti-bacterial and anti-microbial properties of Baidyanath Gokshuradi Guggulu treat UTIs (urinary tract infections)",
      ],
      directions: [
        "Take 1 to 2 tablets with water twice a day or as advised by the physician.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/bh1b6s1osxtc1wcbwiao.jpg",
  },
  {
    id: 69,
    categoryId: 7,
    itemName: "Patanjali Divya Renogrit Tablet",
    itemPrice: "240",
    highlights: [
      "Supports renal health",
      "Made using natural herbs",
      "Prevents kidney disorders",
    ],
    desc: {
      keybenefit: [
        "The formulation helps to prevent renal damage",
        "It helps to keep the kidneys healthy",
        "The tablets help to prevent and manage renal disorders",
      ],
      directions: ["Use as directed on the label or by the physician"],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/18f454f5-64ae-4614-893b-29f0cf178a53.jpeg",
  },
  {
    id: 70,
    categoryId: 7,
    itemName: "Baidyanath Prostaid Tablet",
    itemPrice: "161",
    highlights: [
      "Useful in treating enlarged prostate",
      "Made using natural herbs",
      "Helpful in clearing out blockages in the urinary system",
    ],
    desc: {
      keybenefit: [
        "Shilajit assists in reducing inflammation and pain",
        "Shatavari or asparagus root is a soothing remedy for inflammation caused due to enlarged prostate",
        "It helps heal the urinary system by clearing out blockages",
      ],
      directions: [
        "Two tablets are to be used every morning and again in the evening. This should be used for up to three months at a time.",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The product should not be used as a substitute for a varied diet",
        "This product should be used under medical advice by a physician/certified dietician/nutritionist for children below 3 years of age",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/ztpqqvclfqgcjzwuls1t.jpg",
  },

  //categoryID:8 starts here {Pain relief}
  {
    id: 71,
    categoryId: 8,
    itemName: "Volini Pain Relief Gel",
    itemPrice: "206",
    highlights: [
      "It may relieve pain",
      "It may relieve pain in the joints",
      "It can work great on sports injuries",
    ],
    desc: {
      keybenefit: [
        "The spray can offer relief when in pain",
        "It is effective for pain in the joints, knees, back, shoulders, and neck",
        "It can work great on sports injuries such as muscle pulls, sprains, and strain",
      ],
      directions: [
        "The Volini pain relief bottle should be shaken well before spraying",
        "Hold the spray bottle at a 5cm distance from the affected area and spray",
        "You can use the spray about three to four times daily or as recommened by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The Volini pain relief spray is meant for external application only",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/635fd23716e84269a9fce803978b4f14.jpg",
  },
  {
    id: 72,
    categoryId: 8,
    itemName: "Volini Spray",
    itemPrice: "272",
    highlights: [
      "Provides relief in case of muscle pain, sprain, pain in the joints, knee, back, neck and shoulder",
      "Helps in pain caused due to muscle pulls, sprain, strain and sports injuries",
      "Microparticles allow deeper penetration and provide quick pain relief",
    ],
    desc: {
      keybenefit: [
        "The spray can offer relief when in pain",
        "It is effective for pain in the joints, knees, back, shoulders, and neck",
        "It can work great on sports injuries such as muscle pulls, sprains, and strain",
      ],
      directions: [
        "The Volini pain relief bottle should be shaken well before spraying",
        "Hold the spray bottle at a 5cm distance from the affected area and spray",
        "You can use the spray about three to four times daily or as recommened by your physician",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The Volini pain relief spray is meant for external application only",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/2f1dda5112d048f2baf1b99506b72059.jpg",
  },
  {
    id: 73,
    categoryId: 8,
    itemName:
      "Moov Pain Relief Cream for Back Pain, Joint Pain, Knee Pain, Muscle Pain",
    itemPrice: "68",
    highlights: [
      "The mint leaves in Moov pain relief cream gives a cooling effect to the pain and treat the sore muscles and relieve joint aches",
      "Turpentine oil helps to alleviate tissue discomfort and relax muscles",
      "Eucalyptus oil in Moov pain relief cream is a great massage lotion for joint pain and provides a relaxing warmth ",
    ],
    desc: {
      keybenefit: [
        "Moov Pain Relief Cream reduces irritation and swelling around the affected area",
        "The mint leaves in Moov pain relief cream gives a cooling effect to the pain and treat the sore muscles and relieve joint aches",
        "Eucalyptus oil in Moov pain relief cream is a great massage lotion for joint pain and provides a relaxing warmth ",
      ],
      directions: [
        "Spread two pulp full of Moov Pain Relief Cream on the affected area to form a thin film",
        "Massage gently to facilitate the penetration",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
        "The Volini pain relief spray is meant for external application only",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/pzgaxs8vjyhuguiwmv5f.jpg",
  },
  {
    id: 74,
    categoryId: 8,
    itemName: "Saridon Headache Relief Tablet",
    itemPrice: "39",
    highlights: [
      "Helps to treat headache",
      "Effective for different headache types of headache spread across, on the sides and back of head",
      "Provides relief with just one tablet",
    ],
    desc: {
      keybenefit: [
        "Saridon is a remedy for headaches.",
        "It is effective for different headache types of headache spread across, on the sides and back of the head.",
        "Unique triple action formula for Quick Headache Relief",
      ],
      directions: [
        "Take this medicine as recommended by your doctor. Ideally, adults are advised to take one tablet every 4-6 hours but not exceeding 3 tablets in a day. It is not advised for children younger than 12 years of age. ",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Keep out of reach of the children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/s0dcfx0trz6lf9zczab4.jpg",
  },
  {
    id: 75,
    categoryId: 8,
    itemName: "Healthtokri Electric Rechargeable Heating Gel Warm Bag",
    itemPrice: "251",
    highlights: [
      "Helps provide relief from various muscular pains",
      "Retains heat for a long period of time",
      "Portable and rechargeable",
    ],
    desc: {
      keybenefit: [
        "Rechargeable heating pad is easy to use",
        "Requires low electricity consumption",
        "Helps provide relief from pains and sprains",
        "Simple to use as it does not require filling of water",
      ],
      directions: [
        "Plug the male pin of the cable into the electric socket and plug in the other end to the female electric socket in the bag",
        "Remove the plug now and use the hot bag as per your needs",
        "If the bag has lost the heat after use, then reheat using the same process",
      ],
      Safetyinfo: [
        "Do not use the device when it is plugged into a power source",
        "Cool down the heating pad after use before storing",
        "If there is any leakage, it must not be used",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/rnel0jwng6x8y3lmn5kf.png",
  },
  {
    id: 76,
    categoryId: 8,
    itemName: "Dr Ortho an Ayurvedic Medicine Oil",
    itemPrice: "236",
    highlights: [
      "Provides relief from all kinds of pains and aches",
      "Unique formulation of 8 potent and natural oils",
      "Helps relieve muscle soreness and discomfort",
    ],
    desc: {
      keybenefit: [
        "Helps relieve muscle aches and discomfort",
        "Provides relief from joint pain and inflammation",
        "Its lightweight and quick absorption formula provide a calming and soothing effect on the skin",
        "Improves muscle stiffness and soreness",
      ],
      directions: [
        "Gently massage 5ml to 10ml on the affected area. Repeat it twice a day or as directed by the physician.",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dosage",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/qjz8l72piinjwwynexks.png",
  },
  {
    id: 77,
    categoryId: 8,
    itemName: "Iodex Ultra Gel",
    itemPrice: "124",
    highlights: [
      "Penetrates deeply and relieves internal inflammation",
      "Provides soothing and effective relief from different body pains",
      "Helps to provide relief in back pain, joint pain, sprains and strains",
      "Has a pleasant fragrance and has a non-greasy application",
    ],
    desc: {
      keybenefit: [
        "Iodex UltraGel penetrates skin 7 times deeper and provides effective and long-lasting relief from multiple types of body pain",
        "It supports better penetration, reduces internal swelling/inflammation and treats pain at its root",
        "Iodex Ultra gel has a pleasant fragrance and has a non-greasy application",
        "Beneficial for treating neck and shoulder pain, back pain, muscular pain, joint pain, sprains and osteoarthritis",
      ],
      directions: [
        "Apply 2 to 4 gm gently on the affected area, 3 to 4 times a day and wash your hands thoroughly after use.",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/hwouityfgkycdkbbwsiy.jpg",
  },
  {
    id: 78,
    categoryId: 8,
    itemName: "Volini Maxx Gel",
    itemPrice: "139",
    highlights: [
      "Strong pain relief spray will help to provide relief from pain",
      "India's first pain relief spray with 2% diclofenac",
      "It will take care of your back pain and give you instant relief",
    ],
    desc: {
      keybenefit: [
        "It ensures relief from moderate to severe muscle pain, so you can bounce back instantly",
        "Diclofenac is a non-steroidal anti-inflammatory drug (NSAID) with analgesic and antipyretic properties",
        "Menthol and methyl salicylate are known as counterirritants. They work by causing the skin to feel cool and then warm. These feelings on the skin distract you from feeling the aches/pains deeper in your muscles, joints, and tendons",
      ],
      directions: [
        "Apply Volini Maxx Gel on the skin and rub slowly till completely absorbed.",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/94abe074ec3e44098d5875c81f70b434.jpg",
  },
  {
    id: 79,
    categoryId: 8,
    itemName: "Disprin Regular 325mg Effervescent Tablet",
    itemPrice: "13",
    highlights: [
      "Absorbs and dissolves away the pain fast",
      "Provides relief from headache and migraine",
      "Helps to provide support in relieving mild to moderate nerve pain (neuralgia)",
    ],
    desc: {
      keybenefit: [
        "May be used as an anti-inflammatory and analgesic which help to relieve pain and swelling",
        "It is used to bring down high body temperatures and may prevent recurrence of heart attacks or strokes by thinning the blood",
        "Relieving aches, pains and fever associated with colds and flu",
      ],
      directions: [
        "You should take it as your doctor advises",
        "Do not take more or use it for longer than recommended",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/yhl9lmgxhj1pfbtnc0ts.jpg",
  },
  {
    id: 80,
    categoryId: 8,
    itemName: "Dhootapapeshwar Swamala",
    itemPrice: "1155",
    highlights: [
      "Boosts immunity and maintains a fit body",
      "Relieves joint pain",
      "Aids in managing respiratory-related concerns",
    ],
    desc: {
      keybenefit: [
        "Promotes nourishment of important body constituents - saptadhatus from rasa to shukra as well as oja",
        "It helps keep common infections at bay",
        "Acts as an excellent revitaliser and immunity booster",
      ],
      directions: [
        "Take 1 to 2 tablespoonfuls morning-evening on an empty stomach or as directed by the ayurvedic doctor.",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/nc1hvrzxl4mexlttinrs.png",
  },
  //categoryID:9 starts here {Respiratory care}

  {
    id: 81,
    categoryId: 9,
    itemName: "Otrivin Oxy Fast Relief Adult Nasal Spray",
    itemPrice: "85",
    highlights: [
      "Helps to provide relief from nasal congestion",
      "Helps to control excessive nasal excretion",
      "Facilitates aid in case of swollen blood vessels",
    ],
    desc: {
      keybenefit: [
        "Helps in unblocking nasal congestion",
        "Helps in reducing excessive nasal secretion",
        "Starts action in 25 seconds and provides quick relief",
      ],
      directions: [
        "Sit comfortably with the spray bottle in your hand. Open the bottle and place the nozzle of the nasal spray just inside the blocked nostril. Squeeze the spray pack hard in the centre of the bottle and inhale deeply. Take a deep breath. Repeat for the other nostril and replace the cap after use. Adults and Children aged 12 years or more should spray once into each nostril, upto 3 times a day or, as directed by the physician.",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/uaerylojm65fdh0o0dfo.jpg",
  },
  {
    id: 82,
    categoryId: 9,
    itemName:
      "Tata 1mg 3 Ply Surgical Mask with Meltblown Filter and Nose Pin 50 Mask Light Blue",
    itemPrice: "392",
    highlights: [
      "Has comfortable elastic ear-bands",
      "Provides triple-layer protection with melt-blown filter",
      "Has a Bacterial Filtration Efficiency (BFE) ≥ 98.5%",
    ],
    desc: {
      keybenefit: [
        "1- Inner layer of soft non-woven fabric: Absorbs droplets from exhaled breath",
        "2- Middle layer made of innovative Melt Blown fabric: Filters out dust and pollen and highly breathable",
        "3- Outer Layer of non-woven fabric: Blocks particles",
        "Provides triple-layer protection with melt-blown filter",
      ],
      directions: [
        "Hold the mask by the ear loops and place a loop around each year",
        "Put the mask over the nose and mouth by placing the loops comfortably around the ears",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Discard after every use or if it is damaged, torn, or loose",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/2b18a9de0355455681ec4bb004f1b21b.jpg",
  },
  {
    id: 83,
    categoryId: 9,
    itemName: "2baconil 21mg Nicotine Transdermal Patch Step 1",
    itemPrice: "825",
    highlights: [
      "Provides aid to quit smoking",
      "Helps to reduce the withdrawal symptoms",
      "Allows the smoker to focus on the psychological aspects of quitting",
    ],
    desc: {
      keybenefit: [
        "Nicotine is a stimulant and detoxifying agent",
        "Reduces withdrawal symptoms, allowing the smoker to focus on the psychological aspects of quitting",
      ],
      directions: [
        "1 patch a day for 4 weeks",
        "Please refer to the Therapy Schedule for usage instructions",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/aa019eea99e44f148597400b045cc144.jpg",
  },
  {
    id: 84,
    categoryId: 9,
    itemName: "Dr Morepen PO 14 Pulse Oximeter",
    itemPrice: "1266",
    highlights: [
      "Easy to read OLED display",
      "Measures pulse rate as well",
      "Easy to use the device for spot checks",
    ],
    desc: {
      keybenefit: [
        "This device has an easy-to-read OLED display",
        "It is equipped with different display modes",
        "Indicates low battery and battery capacity",
      ],
      directions: [
        "Insert your finger and the results will be displayed on the display within 5 seconds.",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/o291ovg9uecjswn7wz1b.jpg",
  },
  {
    id: 85,
    categoryId: 9,
    itemName: "Vicks Inhaler",
    itemPrice: "56",
    highlights: [
      "Economical, compact and effective product",
      "Gives fast and temporary mobile relief from cold",
      "Opens up clogged nose due to cold, hay fever and upper respiratory tract allergy",
    ],
    desc: {
      keybenefit: [
        "Economical, compact and effective product",
        "Gives fast and temporary mobile relief",
        "Opens up clogged nose due to cold, hay fever and upper respiratory tract allergy",
      ],
      directions: [
        "Inhale medicated vapors through a nostril while holding the other nostril closed",
        "Inhale deeply to make breathing free and cool",
      ],
      Safetyinfo: [
        "Keep away from children",
        "Read the label carefully before use",
        "Store in a cool, dry place away from direct sunlight",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/l21qw4sgwgrjrwrwgajw.jpg",
  },
  {
    id: 86,
    categoryId: 9,
    itemName: "Omron CMS50N Contec Pulse Oximeter",
    itemPrice: "1328",
    highlights: [
      "Measures pulse oxygen saturation and pulse rates",
      "Features an auto rotation system",
      "Comes with an adjustable alarm",
    ],
    desc: {
      keybenefit: [
        "It features an auto rotation system and comes with an adjustable alarm",
        "Has a low battery indicator and brightness settings to adjust the screen brightness",
        "Shows the recording of the last reading and comes with an automatic on/off technology",
      ],
      directions: [
        "Open the clip and place your finger in the oximeter",
        "Press the on-off button. Do not shake the finger and stay relaxed during the process",
      ],
      Safetyinfo: [
        "Clean the device using a soft cloth damped with 75% of medical alcohol (make sure the device is powered off)",
        "Avoid pouring liquids on the device while cleaning and do not allow any liquid into the product",
        "Keep the operating environment free of dust, vibrations, corrosive or flammable materials and extremes of temperature and humidity",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/dk4bsseilzpnfr953q7e.png",
  },
  {
    id: 87,
    categoryId: 9,
    itemName: "Dr Morepen VP 06 Breathe Free Vaporizer",
    itemPrice: "275",
    highlights: [
      "Helpful in relieving respiratory problems",
      "Produces steam vapours quickly to help clear the nasal passages",
      "Useful in alleviating common cold, bronchitis, sinusitis, asthma etc.",
    ],
    desc: {
      keybenefit: [
        "It is a steam inhalator and facial sauna that produces steam vapours in seconds",
        "It is highly effective and easy to use and clean",
        "It is portable, ideal for home use, and can be conveniently carried during travel as well",
      ],
      directions: [
        "Read the manufacturer's instructions",
        "Place the vaporizer on a flat surface at a safe distance from human contact",
        "Inhale the steam through the nose or mouth",
      ],
      Safetyinfo: [
        "Read the label carefully before use",
        "Store in a cool and dry place away from direct sunlight",
        "Use tap water only and do not use R.O water",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/hlhlwmjbwpzgzb5s6ijx.jpg",
  },
  {
    id: 88,
    categoryId: 9,
    itemName: "Patanjali Divya Swasari Pravahi",
    itemPrice: "80",
    highlights: [
      "Helps to treat respiratory problems including asthma",
      "Improves symptoms of cold and cough",
      "Provides relief from the attacks of breathlessness",
    ],
    desc: {
      keybenefit: [
        "Used as  a tonic for all types of respiratory problems",
        "Treats cold, serious cough, asthma, cough, problems in ribs, and other diseases- Provides relief from the sudden attacks of breathlessness",
        "Treats the respiratory diseases in a safe and natural way and ensures that the lungs function efficiently",
      ],
      directions: [
        "Consume Patanjali Divya Swasari Pravahi as directed by the physician. Ideally, it is recommended to take 1-2 teaspoonful (5-10ml) twice or thrice a day. Do not take more than the daily recommended dose of this supplement as it may lead to side effects. It is advised to use a measuring spoon or cup to dispense the exact prescribed quantity of this syrup.",
      ],
      Safetyinfo: [
        "Store in a cool and dry place (below 25°C).",
        "Protect from moisture.",
        "Keep out of reach of children.",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/tzwco67hdrnqeldtok5p.jpg",
  },
  {
    id: 89,
    categoryId: 9,
    itemName: "Cofsils Lozenges Orange",
    itemPrice: "26",
    highlights: [
      " Amylmetacresol: Antiseptic used in the treatment of infections of the mouth and throat such as throat infection, throat discomfort, mouth infection and other related problems",
      "Dichlorobenzyl Alcohol: Used as a mild antiseptic, able to kill bacteria and viruses associated with mouth and throat infections",
    ],
    desc: {
      keybenefit: [
        " Amylmetacresol: Antiseptic used in the treatment of infections of the mouth and throat such as throat infection, throat discomfort, mouth infection and other related problems",
        "Dichlorobenzyl Alcohol: Used as a mild antiseptic, able to kill bacteria and viruses associated with mouth and throat infections",
      ],
      directions: [
        "Take one lozenge every three hours or as directed by the physician",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dose",
        "Read the label carefully before use",
        "Keep out of the reach and sight of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/vku1bgimm9wicwhrhbma.jpg",
  },
  {
    id: 90,
    categoryId: 9,
    itemName: "Dabur Honitus Herbal Cough Remedy",
    itemPrice: "197",
    highlights: [
      "Acts as an effective herbal remedy for cough",
      "Helps to relieve sore throat and congestion",
      "Improves the symptoms of dry cough",
    ],
    desc: {
      keybenefit: [
        "Honey helps relieve cough and throat irritation",
        "Tulsi has anti-tussive properties that help in relieving cough and cold symptoms",
        "Mulethi acts as a sore throat reliever ,Sunthi and banapsha have expectorant properties that help in the expulsion of phlegm, thus allowing you to recover faster",
      ],
      directions: [
        "Children: 1 teaspoon 3-4 times a day",
        "Adults: 2 teaspoons 3-4 times a day",
      ],
      Safetyinfo: [
        "Do not exceed the recommended dose",
        "Read the label carefully before use",
        "Keep out of the reach and sight of children",
      ],
    },
    itemImage:
      "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/cropped/umtjm9jqy8dblfr3cqnm.jpg",
  },
];
